import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestSettingsPut = {
    path: "/settings",
    method: RouteHttpVerb.PUT
};
export { locationRestSettingsPut };
